export enum EnumTipoCantidad {
  Consumo_Convencional = 1,
  Consumo_Electrico = 2,
  Consumo_Telemedido = 3,
  Consumo_Telemedido_Estimado = 4,
  Consumo_No_Telemedido = 5,
  Consumo_No_Telemedido_Estimado = 6,
  Merma = 7,
  Ajustes = 8,
  Entrada_RT = 9,
  Emision = 10,
  TotalRepartos = 11,
  Cisternas = 12,
  Consumo_Otros = 13,
  Consumo = 14,
  ConsumoEstimado = 23,
  Qd_contratada = 24,
  Qa_estimada = 25,
  Capacidad_Contractual = 26,
  Libre = 27,
  Nominacion = 28,
  Consumo_Real = 29,
  DiarioMedioMedido = 30,
  Resto = 31,
  Fijo = 32,
  Porcentaje = 33,
  BAD = 34,
  PresionAtmosferica,
  PresionSuministro,
  Temperatura,
  FactorConversion,
  FactorK,
  PCS,
  Zeta,
  Densidad,
  n2,
  CO2,
  H2,
  LecturaDesde,
  LecturaHasta,
  Historico,
  PCI,
  Ajuste_AE,
  Ajuste_AS,
  Ajuste_Excesos_Potencia,
  Ajuste_Potencia_Maxima,
  Ajuste_Q1,
  Generacion_No_Telemedida,
  Generacion_Telemedida,
  Lectura_desde_AE,
  Lectura_desde_AS,
  Lectura_desde_Excesos_Pot,
  Lectura_desde_Potencia_Max,
  Lectura_desde_Q1,
  Lectura_hasta_AE,
  Lectura_hasta_AS,
  Lectura_hasta_Excesos_Pot,
  Lectura_hasta_Potencia_Max,
  Lectura_hasta_Q1,
  PorcentajePerdidas,
  Reactiva_Q1,
  Reactiva_Q1_No_Telemedida,
  Reactiva_Q1_Telemedida,
  Reactiva_Q2_Telemedida,
  Reactiva_Q3_Telemedida,
  Reactiva_Q4_Telemedida,
  VAsTrafo,
  Excesos_Potencia,
  Maximos_Potencia,
  PotenciaMaxDemandada,
  ModoControlPotencia,
  IndicativoCurvaCarga,
  Capacidad_Contractual_sin_Fijacion = 96,
  Libre_sin_Fijacion = 97,
  Nominacion_sin_Fijacion = 98,
  Consumo_Real_sin_Fijacion = 99,
  PPA = 100,
  Consumo_Libre_Tras_PPA = 102,
  PPASolar = 105,
  PPAWind = 106
}
